import React, { useEffect } from "react";
import CloseIcon from "../../assets/img/common/close-gray-icon.jpg";
import { useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import TelegramIcon from "../../assets/img/social-media-icons/telegram-circle-icon.png";
import WhatsappIcon from "../../assets/img/social-media-icons/whatsapp-circle-icon.png";
import LinkedInIcon from "../../assets/img/social-media-icons/linkedin-circle-icon.png";
import EmailIcon from "../../assets/img/social-media-icons/email-circle-icon.png";
import {
  EmailShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  WhatsappShareButton,
} from "react-share";
import notify from "./notify";
// SharePopup Component
const SharePopup = ({
  title,
  summary,
  show,
  setShow,
  shareType = "project",
}) => {
  // Ref for modal
  const modalRef = useRef(null);

  // Handle modal close
  const handleClose = () => {
    setShow(false);
  };

  // UseOutsideClick hook to close modal on outside click
  useOutsideClick(modalRef, handleClose, null, show);

  // Effect to manage body overflow based on modal visibility
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  // Handle share link click event
  const handleShareLink = async (e) => {
    var copyTextarea = document.querySelector(".link-textarea");
    copyTextarea.focus();
    copyTextarea.select();

    try {
      // Attempt to copy the link to clipboard
      let successfulCopied = document.execCommand("copy");

      if (successfulCopied) {
        notify(
          `The ${shareType} link was copied to your clipboard!`,
          "success"
        );
      } else {
        // If copy command fails, fallback to using navigator.clipboard
        await navigator.clipboard
          .writeText(`See my ${shareType} on FunDeSci : \n\n
        ${title} \n\n
        Summary : ${summary.slice(0, 150)} ...
         \n\n
        ${window.location}
        `);
        notify(
          `The ${shareType} link was copied to your clipboard!`,
          "success"
        );
      }
    } catch (err) {
      notify(`Error in copying the ${shareType} link!`, "error");
    }
  };

  return (
    <div className="min-w-[100vw] w-full h-screen flex justify-center items-center bg-[#241b4795] backdrop-blur-md fixed top-0 left-0  roboto-font z-50 ">
      <div
        ref={modalRef}
        className="w-11/12 md:w-[450px] flex flex-col items-center pb-10 pt-1 rounded-3xl bg-white "
      >
        {/* Modal close button */}
        <div className="w-full flex justify-end py-3 px-5">
          <button onClick={handleClose}>
            <img src={CloseIcon} alt="CloseIcon" className="w-5 h-5" />
          </button>
        </div>

        {/* Share modal title */}
        <span className="text-2xl font-semibold abel-font ">
          Share This {shareType}
        </span>

        {/* Share buttons */}
        <div className="flex items-center gap-3 mt-5">
          <TelegramShareButton title={title} url={window.location}>
            <img src={TelegramIcon} alt="TelegramIcon" className="w-10 h-10" />
          </TelegramShareButton>

          <WhatsappShareButton
            title={title}
            separator=":: "
            url={window.location}
          >
            <img src={WhatsappIcon} alt="WhatsappIcon" className="w-10 h-10" />
          </WhatsappShareButton>
          <LinkedinShareButton
            title={title}
            summary={summary}
            source={"https://fundesci.com"}
            url={window.location}
          >
            <img src={LinkedInIcon} alt="LinkedInIcon" className="w-10 h-10" />
          </LinkedinShareButton>
          <EmailShareButton
            url={window.location}
            subject={`See my ${shareType} on FunDeSci`}
            body={`${title} \n summary : ${summary}`}
          >
            <img src={EmailIcon} alt="EmailIcon" className="w-10 h-10" />
          </EmailShareButton>
        </div>

        {/* Share link input and copy button */}
        <div className="w-[95%] sm:w-96 h-10 rounded-3xl bg-custom-gray-500 flex justify-between p-1 mt-5">
          <div
            className="w-full pl-3 pr-6 text-sm font-[poppins] relative"
            placeholder="Enter your email"
          >
            <input
              readOnly
              value={String(window.location)}
              className="absolute left-0 top-0 w-full h-full rounded-3xl px-4 bg-custom-gray-200 appearance-none  border-none outline-none"
            />

            <textarea
              readOnly
              className=" h-1 w-1 opacity-0 rounded-md flex justify-center items-center appearance-none focus:border-none focus-within:outline-none border-none outline-none resize-none overflow-hidden select-none link-textarea"
            >
              {`See my ${shareType} on FunDeSci : \n\n${title} \n\nSummary : ${summary.slice(
                0,
                150
              )} ... \n\n${window.location}
                 `}
            </textarea>
          </div>
          <button
            onClick={handleShareLink}
            className="bg-light-primary flex justify-center items-center h-full min-w-[80px] text-white text-sm  rounded-[20px] ml-2"
          >
            Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default SharePopup;
